var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showMessageBox
    ? _c("div", { staticClass: "message-box-bg flex-center" }, [
        _c("div", { staticClass: "message-box" }, [
          _c(
            "div",
            { staticClass: "message-box-main" },
            [
              _c("div", { staticClass: "message-box-top" }, [
                _c("h5", { staticClass: "flex-center" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "home.walletConnect.acceptInvitationMessageBox.connectYourAddress"
                        )
                      ) +
                      " "
                  ),
                ]),
                _c("i", {
                  staticClass: "icon icon-close",
                  on: { click: _vm.onShowMessageBox },
                }),
              ]),
              _c("div", { staticClass: "message-box-content" }, [
                _c("p", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "home.walletConnect.acceptInvitationMessageBox.youShouldText"
                        )
                      ) +
                      " "
                  ),
                ]),
                _c("p", { staticClass: "text-max text-invite-address" }, [
                  _vm._v(_vm._s(_vm.inviteAddress)),
                ]),
                _c("p", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "home.walletConnect.acceptInvitationMessageBox.followText"
                        )
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "stpe-block flex-center" }, [
                _c("div", { staticClass: "stpe-box flex-center" }, [
                  _c("i", { staticClass: "icon icon-authorization-gas-fee" }),
                  _c("h6", { staticClass: "text-max" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "home.walletConnect.acceptInvitationMessageBox.authorization"
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "stpe-box flex-center" }, [
                  _c("i", { staticClass: "icon icon-authenticate-yourself" }),
                  _c("h6", { staticClass: "text-max" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "home.walletConnect.acceptInvitationMessageBox.verification"
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ]),
              _c(
                "ButtonCommon",
                {
                  staticClass: "flex-center box-but",
                  attrs: { type: "marginXBridge", width: "280px" },
                  on: { click: _vm.toConfirm },
                },
                [
                  _c("strong", { staticClass: "text-max" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "home.walletConnect.acceptInvitationMessageBox.confirm"
                        )
                      )
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "message-box-bott" }, [
            _c("p", { staticClass: "message-box-bott-addr" }, [
              _c(
                "a",
                {
                  staticClass: "a-link",
                  attrs: {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: _vm.aLink,
                  },
                },
                [_vm._v(_vm._s(_vm.aLink))]
              ),
            ]),
            _c("p", { staticClass: "text-min text-opacity" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "home.walletConnect.acceptInvitationMessageBox.referText"
                    )
                  ) +
                  " "
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }